module.exports = __webpack_public_path__ + "img/profitability9.a6e1a645.png";